import { type PropsWithChildren } from 'react';

import type { NumericalThresholdConfig } from '../../core/types/thresholds.js';

/**
 * @public
 */
export type HistogramThresholdIndicatorProps = NumericalThresholdConfig;

/**
 * @public
 */
export const ThresholdIndicator = (
  props: PropsWithChildren<HistogramThresholdIndicatorProps>,
) => null;

ThresholdIndicator['displayName'] = 'HistogramChart.ThresholdIndicator';
